import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const StnInward = () => {
   useAuthRedirect();
  const { stnNo, stnBranch } = useParams();
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");

  const [header, setHeader] = useState({});
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const canView  = hasPermission("STN Inward", "view");

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
                Swal.fire({
                        title: "Fetching STN Details",
                        html: `
                          <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                            <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                          </div>
                          <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch STN Details...</p>
                        `,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                          const style = document.createElement("style");
                          style.innerHTML = `
                            @keyframes progressBar {
                              0% { width: 0% }
                              50% { width: 100% }
                              100% { width: 0% }
                            }
                          `;
                          document.head.appendChild(style);
                        },
                      });
        
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/stnInward_detailsHeader?stnNo=${stnNo}&branch=${branch}`
        );
        if (response.data && response.data.headerDetails?.length > 0) {
          const items = response.data.headerDetails;
          const storeReqHeader = {
            headerNo: items[0].sfIssuesHeader_number || "N/A",
            type: items[0].sfIssuesHeader_type || "N/A",
            transferBranch: items[0].sfIssuesHeader_branchcode || "N/A",
            InwardDate: items[0].sfIssuesHeader_date || "N/A",
            indentNo: items[0].sfIssuesHeader_indentNumber || "N/A",
            remarks: items[0].sfIssuesHeader_remarks || "N/A",
            shift: items[0].sfissuesHeader_shiftNumber || "N/A",
          };
          setHeader(storeReqHeader);
        }
        Swal.close();
      } catch (error) {
                Swal.close();
                        console.error("Error fetching STN Details. Please try again:", error);
                        Swal.fire({
                          icon: "error",
                          title: "Oops!",
                          text: "Error fetching STN Details. Please try again",
                        });
      }
    };

    {canView && (
    fetchIndentDetails()
    )}
  }, [stnNo, branch]);

  useEffect(() => {
    axios
      .get(`https://rfs2.infraconsoft.net.in/api/stnInward_listData?stnNo=${stnNo}&branch=${stnBranch}`)
      .then((response) => {
        setData(response.data.bottomDetails);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [stnNo, stnBranch]);


  if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <div className="back-div">
                        <h2 className="add-txt">STN - Inward View</h2>
                        <Link to={`/inventory/stockTransferNotependingView`}><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                      </div>
          <h2 className="add-txt"></h2>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form">
            <div className="form-row">
              <div className="form-group">
                <label>Store Issue No :</label>
                <input type="text" name="indentNo" value={header.headerNo} readOnly />
              </div>
              <div className="form-group">
                <label>Stock Transferred Date :</label>
                <input type="text"value={header.InwardDate ? new Date(header.InwardDate).toISOString().split("T")[0] : ""} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Stock Transfer From :</label>
                <input type="text" name="type" value={stnBranch} readOnly />
              </div>
              <div className="form-group">
                <label>Type :</label>
                <input type="text" name="branch" value={header.type} readOnly />
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Remarks :</label>
                <input type="text" value={header.remarks} readOnly/>
              </div>

              <div className="form-group">
                <label>Shift :</label>
                <input type="text" value={header.shift} readOnly/>
              </div>
            </div>

           

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    <>
                      {data.map((item, index) => {
                        const value = item.sfIssuesDetail_price * item.sfissuesDetail_issuedQuantity;
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.sfissuesDetail_itemCode}</td>
                            <td>{item.itemmaster_name}</td>
                            <td>{item.itemmaster_uom}</td>
                            <td>{item.sfissuesDetail_issuedQuantity}</td>
                            <td>{item.sfIssuesDetail_price}</td>
                            <td>{value.toFixed(2)}</td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td colSpan={6}><strong>Total Value</strong></td>
                        <td>
                          <strong>
                            {data
                              .reduce((acc, item) => acc + item.sfIssuesDetail_price * item.sfissuesDetail_issuedQuantity, 0)
                              .toFixed(2)}
                          </strong>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <tr>
                      <td colSpan="9">No items</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default StnInward;
